<script setup lang="ts">
import { computed } from 'vue'

export type StatusKind = 'online' | 'offline' | 'connecting' | 'warning' | 'error' | 'idle'

interface Props {
  status: StatusKind
  size?: 'sm' | 'md' | 'lg'
  pulse?: boolean
  label?: string
}

const props = withDefaults(defineProps<Props>(), {
  size: 'md',
  pulse: false,
})

const colorClass = computed(() => {
  switch (props.status) {
    case 'online':     return 'bg-success'
    case 'offline':    return 'bg-fg-subtle'
    case 'connecting': return 'bg-info'
    case 'warning':    return 'bg-warning'
    case 'error':      return 'bg-danger'
    default:           return 'bg-fg-subtle'
  }
})

const sizeClass = computed(() => {
  switch (props.size) {
    case 'sm': return 'h-1.5 w-1.5'
    case 'lg': return 'h-3 w-3'
    default:   return 'h-2 w-2'
  }
})

const shouldPulse = computed(() => props.pulse || props.status === 'connecting')
</script>

<template>
  <span class="inline-flex items-center gap-2">
    <span class="relative inline-flex" :class="sizeClass">
      <span
        class="absolute inset-0 rounded-full"
        :class="colorClass"
      />
      <span
        v-if="shouldPulse"
        class="absolute inset-0 animate-ping rounded-full opacity-75"
        :class="colorClass"
      />
    </span>
    <span v-if="label" class="text-xs text-fg-muted">{{ label }}</span>
  </span>
</template>
